




































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";

class PageBillDetailRequest extends PageRequest {
  keyword: string;
  billId: string;
  billNo: string;
}
@Component({
  components: {},
})
export default class BillDetailed extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) billId: string;
  @Prop({ type: String, default: null }) billNo: string;
  pagerequest: PageBillDetailRequest = new PageBillDetailRequest();
  create() {}
  created() {}
  get list() {
    return this.$store.state.billsdetailed.list;
  }
  async save() {
    this.$emit("input", false);
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("billsdetailed/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("billsdetailed/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.$store.dispatch({
      type: "billsdetailed/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.billsdetailed.pageSize;
  }
  get totalCount() {
    return this.$store.state.billsdetailed.totalCount;
  }
  get currentPage() {
    return this.$store.state.billsdetailed.currentPage;
  }
  get loading() {
    return this.$store.state.billsdetailed.loading;
  }
  columns = [
    {
      type: "index",
      key: "index",
      width: 60,
      fixed: "left",
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("BillNo"),
      key: "billsId",
      fixed: "left",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: this.pagerequest.billNo,
            },
          },
          this.pagerequest.billNo
        );
      },
    },
    {
      title: this.L("MeterNo"),
      key: "meterNo",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("FeeCategory"),
      key: "ammontTypeId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.ammontTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("MeterType"),
      key: "meterTypeId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.meterTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Magnification"),
      key: "magnification",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("Application"),
      key: "applicationId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.applicationId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("FirstReadNum"),
      key: "beginReadNum",
      width: 130,
    },
    {
      title: this.L("LastReadNum"),
      key: "lastReadNum",
      width: 130,
    },
    {
      title: this.L("LastReadTime"),
      key: "lastReadTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("TotalUse"),
      key: "totalUse",
      width: 130,
    },
    {
      title: this.L("TotalAmmount"),
      key: "totalAmmount",
      width: 130,
    },
    {
      title: this.L("TipBeginingUse"),
      key: "secondBeginingUse",
      width: 130,
    },
    {
      title: this.L("TipEndingUse"),
      key: "secondEndingUse",
      width: 130,
    },
    {
      title: this.L("TipThisUse"),
      key: "secondThisUse",
      width: 130,
    },
    {
      title: this.L("TipPrice"),
      key: "secondThisPrice",
      width: 130,
    },
    {
      title: this.L("TipThisTotalAmmount"),
      key: "secondThisTotal",
      width: 130,
    },
    {
      title: this.L("PeakBeginingUse"),
      key: "thirdBeginingUse",
      width: 130,
    },
    {
      title: this.L("PeakEndingUse"),
      key: "thirdEndingUse",
      width: 130,
    },
    {
      title: this.L("PeakPrice"),
      key: "thirdThisPrice",
      width: 130,
    },
    {
      title: this.L("PeakThisTotalAmmount"),
      key: "thirdThisTotal",
      width: 130,
    },

    {
      title: this.L("FlatBeginingUse"),
      key: "firstBeginingUse",
      width: 130,
    },
    {
      title: this.L("FlatEndingUse"),
      key: "firstEndingUse",
      width: 130,
    },
    {
      title: this.L("FlatThisUse"),
      key: "firstThisUse",
      width: 130,
    },
    {
      title: this.L("FlatPrice"),
      key: "firstThisPrice",
      width: 130,
    },
    {
      title: this.L("FlatThisTotalAmmount"),
      key: "firstThisTotal",
      width: 130,
    },
    {
      title: this.L("ValleyBeginingUse"),
      key: "fourBeginingUse",
      width: 130,
    },
    {
      title: this.L("ValleyEndingUse"),
      key: "fourEndingUse",
      width: 130,
    },
    {
      title: this.L("ValleyThisUse"),
      key: "fourThisUse",
      width: 130,
    },
    {
      title: this.L("ValleyPrice"),
      key: "fourThisPrice",
      width: 130,
    },
    {
      title: this.L("ValleyThisTotalAmmount"),
      key: "fourThisTotal",
      width: 130,
    },
  ];
  //列合计
  handleSummary({ columns, data }) {
    const sums = {};
    columns.forEach((column, index) => {
      const key = column.key;
      if (key === "billsId") {
        sums[key] = {
          key,
          value: this.L("Total"),
        };
        return;
      } else if (
        key === "totalUse" ||
        key === "totalAmmount" ||
        key === "firstThisUse" ||
        key === "firstThisTotal" ||
        key === "secondThisUse" ||
        key === "secondThisTotal" ||
        key === "thirdThisUse" ||
        key === "thirdThisTotal" ||
        key === "fourThisUse" ||
        key === "fourThisTotal"
      ) {
        const values = data.map((item) => Number(item[key]));
        if (!values.every((value) => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: v.toFixed(4),
          };
        } else {
          sums[key] = {
            key,
            value: "N/A",
          };
        }
      } else {
        const key = column.key;
        sums[key] = {
          key,
          value: "",
        };
      }
    });
    return sums;
  }
  @Watch("billId", { deep: true })
  @Watch("billNo", { deep: true })
  getitemId() {
    this.pagerequest.billId = this.billId;
    this.pagerequest.billNo = this.billNo;
  }
}
